exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-bekenden__description,.page-bekenden__persona{margin-bottom:100px}.page-bekenden__flipper.flipper{width:200px;height:230px;transform:scale(0);margin-bottom:30px}#page-bekenden .portret{width:200px;height:200px}.page-bekenden__rutte .portret--back{background-image:url(" + require("../../assets/images/rutte-portret.jpg") + ")}.page-bekenden__white .portret--back{background-image:url(" + require("../../assets/images/white-portret.jpg") + ")}.page-bekenden__next-section{opacity:0}.page-bekenden__jobs{height:70px}.page-bekenden__jobs .row{display:flex;align-items:center}.page-bekenden__plus{height:70px;transform:scale(0)}.page-bekenden__job{transform:scale(0)}.page-bekenden__job.page-bekenden__job--left span{align-self:flex-end}#page-bekenden__next-btn{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e58eb62","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-bekenden.vue
// module id = 56
// module chunks = 0